// Externe Bibliotheken
import React, { Component } from 'react';

const params = {
    errorWording: {
        firstName: {
            default: 'Bitte geben Sie einen Vornamen ein.',
            invalid: 'Bitte geben Sie einen gültigen Vornamen ein.',
        },
        lastName: {
            default: 'Bitte geben Sie einen Nachnamen ein.',
            invalid: 'Bitte geben Sie einen gültigen Nachnamen ein.',
        },
        IBAN: {
            default: 'Bitte geben Sie eine IBAN oder Kontonummer ein.',
            invalid: 'Die eingegebene IBAN oder Kontonummer ist ungültig.',
        },
    },
};

class DirectDebit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formValid: false,
            showError: false,
            formErrors: {
                firstName: params.errorWording.firstName.default,
                lastName: params.errorWording.lastName.default,
                IBAN: params.errorWording.IBAN.default,
            },
            directDebitFirstName: '',
            directDebitLastName: '',
            directDebitAccountNumber: '',
        };

        this.ibanLengths = {
            AD: 24,
            AE: 23,
            AT: 20,
            AZ: 28,
            BA: 20,
            BE: 16,
            BG: 22,
            BH: 22,
            BR: 29,
            CH: 21,
            CR: 21,
            CY: 28,
            CZ: 24,
            DE: 22,
            DK: 18,
            DO: 28,
            EE: 20,
            ES: 24,
            FI: 18,
            FO: 18,
            FR: 27,
            GB: 22,
            GI: 23,
            GL: 18,
            GR: 27,
            GT: 28,
            HR: 21,
            HU: 28,
            IE: 22,
            IL: 23,
            IS: 26,
            IT: 27,
            JO: 30,
            KW: 30,
            KZ: 20,
            LB: 28,
            LI: 21,
            LT: 20,
            LU: 20,
            LV: 21,
            MC: 27,
            MD: 24,
            ME: 22,
            MK: 19,
            MR: 27,
            MT: 31,
            MU: 30,
            NL: 18,
            NO: 15,
            PK: 24,
            PL: 28,
            PS: 29,
            PT: 25,
            QA: 29,
            RO: 24,
            RS: 22,
            SA: 24,
            SE: 24,
            SI: 19,
            SK: 24,
            SM: 27,
            TN: 24,
            TR: 26,
            AL: 28,
            BY: 28,
            EG: 29,
            GE: 22,
            IQ: 23,
            LC: 32,
            SC: 31,
            ST: 25,
            SV: 28,
            TL: 23,
            UA: 29,
            VA: 22,
            VG: 24,
            XK: 20,
        };
    }

    format__IBAN(event) {
        let u = event.target.value.toUpperCase();
        let v = u
            .replace(/[^\dA-Z]/g, '')
            .replace(/(.{4})/g, '$1 ')
            .trim();

        return (event.target.value = v);
    }

    validate(fieldName, value) {
        let valid, errorCase;
        let fieldValidationErrors = this.state.formErrors;

        /*
         * Returns 1 if the IBAN is valid
         * Returns FALSE if the IBAN's length is not as should be (for CY the IBAN Should be 28 chars long starting with CY )
         * Returns any other number (checksum) when the IBAN is invalid (check digits do not match)
         */
        const validateIBAN = (input) => {
            const iban = String(input)
                .toUpperCase()
                .replace(/[^A-Z0-9]/g, ''); // keep only alphanumeric characters

            const code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/); // match and capture (1) the country code, (2) the check digits, and (3) the rest

            // check syntax and length
            if (!code || iban.length !== this.ibanLengths[code[1]]) {
                return false;
            }
            // rearrange country code and check digits, and convert chars to int
            const digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, (letter) => {
                return letter.charCodeAt(0) - 55;
            });
            // final check
            return mod97(digits);
        };

        const mod97 = (string) => {
            let checksum = string.slice(0, 2);
            let fragment;

            for (let offset = 2; offset < string.length; offset += 7) {
                fragment = String(checksum) + string.substring(offset, offset + 7);
                checksum = parseInt(fragment, 10) % 97;
            }
            return checksum;
        };

        // field validation
        switch (fieldName) {
            case 'directDebitFirstName':
                valid = value.length > 0;
                errorCase = params.errorWording.firstName?.default;

                if (valid && value.length < 2) {
                    valid = value.length === 2;
                    errorCase = params.errorWording.firstName?.invalid;
                }

                fieldValidationErrors.firstName = valid ? '' : errorCase;

                break;
            case 'directDebitLastName':
                valid = value.length > 0;
                errorCase = params.errorWording.lastName?.default;

                if (valid && value.length < 2) {
                    valid = value.length === 2;
                    errorCase = params.errorWording.lastName?.invalid;
                }

                fieldValidationErrors.lastName = valid ? '' : errorCase;

                break;
            case 'directDebitAccountNumber':
                valid = value.length > 1;

                // auto uppercase
                this.setState({ directDebit_accountNumber: value.toUpperCase() });

                // set errorCase
                errorCase = params.errorWording.IBAN.default;

                if (valid && value.length >= 2) {
                    valid = validateIBAN(value);
                    errorCase = params.errorWording.IBAN.invalid;
                }

                fieldValidationErrors.IBAN = valid ? '' : errorCase;

                break;
            default:
                break;
        }

        this.setState({ formErrors: fieldValidationErrors });

        let paymentData;

        // is valid
        if (
            this.state.directDebitFirstName &&
            this.state.directDebitLastName &&
            this.state.directDebitAccountNumber &&
            !fieldValidationErrors.IBAN &&
            !fieldValidationErrors.firstName &&
            !fieldValidationErrors.lastName
        ) {
            paymentData = Object.assign(this.props.paymentData, {
                paymentValid: true,
                directDebit: {
                    accountOwner: `${this.state.directDebitFirstName} ${this.state.directDebitLastName}`,
                    accountNumber: this.state.directDebitAccountNumber,
                },
            });
        } else {
            paymentData = Object.assign(this.props.paymentData, {
                paymentValid: false,
            });
        }

        this.setState({
            paymentData: paymentData,
        });
        this.props.setPaymentData(paymentData);
    }

    handleUserInput(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({ [name]: value }, () => {
            this.validate(name, value);
        });
    }

    render() {
        return (
            <>
                <div className={`card-body ${this.props.active && 'active'}`}>
                    <div className="form-elements">
                        <div className="form-row">
                            <div>
                                <label htmlFor="directDebitFirstName">Vorname</label>
                                <input
                                    id="directDebitFirstName"
                                    name="directDebitFirstName"
                                    type="text"
                                    placeholder="Vorname"
                                    value={this.state.firstName}
                                    onChange={(e) => this.handleUserInput(e)}
                                />
                                {this.props.alreadyTested && this.state.formErrors['firstName'].length > 0 && (
                                    <div className="text-red error">{this.state.formErrors['firstName']}</div>
                                )}
                            </div>
                            <div>
                                <label htmlFor="directDebitLastName">Nachname</label>
                                <input
                                    id="directDebitLastName"
                                    name="directDebitLastName"
                                    type="text"
                                    placeholder="Nachname"
                                    value={this.state.lastName}
                                    onChange={(e) => this.handleUserInput(e)}
                                />
                                {this.props.alreadyTested && this.state.formErrors['lastName'].length > 0 && (
                                    <div className="text-red error">{this.state.formErrors['lastName']}</div>
                                )}
                            </div>
                        </div>
                        <div className="form-row">
                            <label htmlFor="directDebitAccountNumber">IBAN</label>
                            <input
                                id="directDebitAccountNumber"
                                name="directDebitAccountNumber"
                                type="text"
                                placeholder="IBAN oder Kontonummer"
                                value={this.state.directDebitAccountNumber}
                                onChange={(e) => {
                                    this.handleUserInput(e);
                                    this.format__IBAN(e);
                                }}
                            />
                            {this.props.alreadyTested && this.state.formErrors['IBAN'].length > 0 && (
                                <div className="text-red error">{this.state.formErrors['IBAN']}</div>
                            )}
                        </div>
                    </div>
                    <div className="trust-element">
                        <i className="material-symbols-outlined">check</i>
                        Die Übertragung Ihrer Zahldaten erfolgt verschlüsselt über einen Sicherheitsserver.
                    </div>
                </div>
            </>
        );
    }
}

export default DirectDebit;
